import { gateNames } from '@mp/constants';
import { useCurrentUser, useGate } from '@mp/hooks';
import { useJobForJobDetailsContainer } from '../jobDetailsComponents/graphql';

export const useShiftRelease = ({ jobId }: { jobId: number }) => {
  const { isSaas } = useCurrentUser();
  const { job } = useJobForJobDetailsContainer(jobId);
  const isShiftSwapEnabled = useGate(gateNames.direct_shift_release_pro);

  const canBeRelease = job?.location?.shift_release_enabled;
  const canBeDrop = job?.location?.shift_drop_enabled;
  const canBeSwap = job?.location?.shift_swap_enabled;
  const allowDropWindow = job?.location?.allow_drop_window_hours;
  const allowSwapWindow = job?.location?.allow_swap_window_hours;
  const allowReleaseWindow = job?.location?.allow_release_window_hours;

  const hasReleaseToCancel =
    job?.pending_shift_request?.status === 'pending' ||
    job?.pending_shift_request?.status === 'pending_requestee' ||
    job?.pending_shift_request?.id;

  const showShiftToReleaseButton = isShiftSwapEnabled && isSaas;

  return {
    showShiftToReleaseButton,
    canBeRelease,
    canBeDrop,
    canBeSwap,
    allowDropWindow,
    allowSwapWindow,
    allowReleaseWindow,
    hasReleaseToCancel,
    startTime: job?.starts_time,
    shiftRequestId: job?.pending_shift_request?.id,
  };
};
